<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          أنك غير مخول بالوصول! 🔐
        </h2>
        <p class="mb-2">
          ليس لديك صلاحيات الدخول. عُد للرئيسية !!
        </p>
        <b-button :to="loginRoute()" variant="primary" class="mb-1 btn-sm-block">العودة للرئيسية</b-button>
        <b-img fluid :src="imgUrl" alt="Not authorized page" />
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getUserRoles, getHomeRouteForLoggedInUser } from '@admin/../auth/utils'
export default {
  components: {
    BLink, BImg, BButton, VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },


  },
  methods: {
    loginRoute() {
      console.log(getHomeRouteForLoggedInUser(getUserRoles()))
      return getHomeRouteForLoggedInUser(getUserRoles())
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
